module.exports = __webpack_public_path__ + "article-7051a3ee/bewerbungsschreiben-ausbildung-2aeaa18d09f7bb366804298de5e05bda.jpeg";